import { render, staticRenderFns } from "./ShopHelicopterDetails.vue?vue&type=template&id=4ea8390b&scoped=true&"
import script from "./ShopHelicopterDetails.vue?vue&type=script&lang=js&"
export * from "./ShopHelicopterDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShopHelicopterDetails.vue?vue&type=style&index=0&id=4ea8390b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea8390b",
  null
  
)

export default component.exports